import { Row, Col, Table, } from "react-bootstrap";
import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import defaultimg from "../../icons/noimage.png";
import { WPSH_PWHeatTre_Type, Tubesheet_WPSPage1, Tubesheet_WPSPage2, WPS_Tubesheet_Detail, WPSH_PWHeatTre_Wrap_insulation_material, Wrap_insulation_material } from "./WPSObjects/WPSGroove_entity";
import { WPSHeader } from "./WPSObjects/WPSHeader";
import {
  WPSProcessGridInputTubesheet,
  WPSProcessGridInput2Tubesheet,
  WPS_Grid_Input_2_Tubesheet,
  WPS_Process_Grid_InputProcess_tubesheet,
  WPS_Process_Grid_Select_master_data_TTS,
} from "./WPSObjects/WPS_Process_Grid";
import { SingleInputTextAreaNotesWPS, SingleInput, General_Single_Input_select } from "../utility/forms/inputs/InputsTransaction";
import {
  isAllowCustomSpecialCharacters,
  isAllowDashedPercentageSpecialCharacters,
  isAllowDashedSpecialCharacters,
  isAlphanumericWithPlusAmpersandEqualsPlusMinus,
  isSpecialCharactersNotes,
} from "../../functions/validations";
import { AddLogs } from "../../Services/wps-logs-services";
import { fetchImagePreview } from "../utility/common/TransactionComponents/CommonImages";
import { getAllUserMaster } from "../../Services/user-service";
import { UnifiedSignatureSection } from "../utility/common/TransactionComponents/UnifiedSignatureSection";
import { getActiveItemForProject } from "../../Services/item-services";
import { todayDate } from "../utility/common/helpers/TodayDate";
import { bluestyle, errorstyle, RenderIf } from "../../functions/welding-functions";
import { DotLoader } from "react-spinners";
import SingleValuePopUp from "../utility/ui/modals/SingleValuePopUp";
import { MessageTypes, Action, Status } from "../utility/common/constants/CommonConstants";
import { validateForm, handleChangeNotes, handleKeyDown } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import {
  handleGeneralSubmit,
  handleGeneralSubmitTemp, handleDetailChange, handleHeaderchange, handleArrayChange
  , DisableFields, emptyError
} from "./WPSObjects/WPSCommonUtils";
import { handleHeaderDetailAdd, handleStatusChange } from "./WPSObjects/WPSDataService"
import { maxlength_WPS, maxLength_WPS } from "./WPSObjects/maxlength_WPS";
import { showWarning } from "../utility/ui/notifications/Toaster";

const WPSTubesheetProcedureSpec = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      setIsEditedPage2,
      setBtnDisabled,
      isReadonly,
      action,
      setAction,
    },
    ref
  ) => {
    const avatar = { defaultimg };
    const [ItemActive, setItemActive] = useState([]);
    const [loading, setLoading] = useState(false);
    const [IsEdited, setIsEdited] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [popUp, setPopUp] = useState({
      name: "",
      type: "",
      key: "",
      value: "",
      rowIndex: -1,
      colIndex: -1,
    });
    const [previewuser, setPreviewuser] = useState(avatar.defaultimg);
    const [previewapproved, setPreviewapproved] = useState(avatar.defaultimg);
    const [users, setUsers] = useState(null);
    let Band = sessionStorage.getItem("Band");
    let folderwld = "wld_signatures";
    const location = useLocation();

    const isDisabled = false;

    /**
     * PROJECT CHANGE EFFECT - ITEM CODE CLEARING BEHAVIOR
     * 
     * BUSINESS LOGIC:
     * When project number changes, the item codes are automatically cleared.
     * This is CORRECT BEHAVIOR because:
     * 
     * 1. PROJECT-SPECIFIC ITEMS:
     *    - Each project has its own approved item codes
     *    - Item codes from Project A are not valid for Project B
     *    - Prevents invalid item selection across projects
     * 
     * 2. DATA INTEGRITY:
     *    - Ensures only project-approved consumables are used
     *    - Maintains traceability and compliance requirements
     *    - Prevents cross-project contamination of specifications
     * 
     * 3. FETCHITEM PROCESS:
     *    - Calls getActiveItemForProject(headerObj.WPSH_Project_No)
     *    - Filters items specific to the selected project
     *    - Updates ItemActive state with project-specific items
     *    - Forces user to reselect appropriate items for new project
     * 
     * 4. CLEARING MECHANISM:
     *    - When project changes, existing WPSD_WP_ItemCode values become invalid
     *    - User must reselect from new project's approved item list
     *    - Prevents WPS approval with wrong project items
     * 
     * This behavior ensures WPS compliance and prevents specification errors.
     */
    useEffect(() => {
      fetchitem();
    }, [headerObj.WPSH_Project_No]);

    const showPopUp = (name, type, key, value, rowIndex, colIndex) => {
      setPopUp({ name, type, key, value, rowIndex, colIndex });
      setShowForm(true);
    };

    const setPopUpData = (data) => {
      if (data.name === "ItemActive") {
        let onChangeVal = [...detailObj];

        // Initialize arrays if they don't exist
        if (!onChangeVal[popUp.rowIndex]["WPSD_WP_ItemCode"]) {
          onChangeVal[popUp.rowIndex]["WPSD_WP_ItemCode"] = [];
        }
        if (!onChangeVal[popUp.rowIndex]["WPSD_WP_WeldDesc"]) {
          onChangeVal[popUp.rowIndex]["welddesc"] = [];
        }
        if (!onChangeVal[popUp.rowIndex]["weldweight"]) {
          onChangeVal[popUp.rowIndex]["weldweight"] = [];
        }

        onChangeVal[popUp.rowIndex]["WPSD_WP_ItemCode"][popUp.colIndex] = data.result.wld_itemcode;
        onChangeVal[popUp.rowIndex]["welddesc"][popUp.colIndex] = data.result.wld_description || "";
        onChangeVal[popUp.rowIndex]["weldweight"][popUp.colIndex] = data.result.wld_weight || "";
        setdetailObj(onChangeVal);
        setError((prevState) => ({
          ...prevState,
          WPSD_WP_ItemCode: { status: false, message: "" },
        }));
      }
    };

    /**
     * FETCH PROJECT-SPECIFIC ITEMS
     * 
     * PURPOSE:
     * Retrieves and filters active item codes approved for the selected project.
     * 
     * PROCESS:
     * 1. Call getActiveItemForProject() with current project number
     * 2. Filter out empty/blank item codes
     * 3. Update ItemActive state with valid project items
     * 4. This triggers re-rendering of item selection dropdowns
     * 
     * RESULT:
     * - ItemActive contains only items valid for current project
     * - Previous item selections are invalidated (correct behavior)
     * - User must reselect items from new project's approved list
     * - Ensures WPS uses only project-approved consumables
     */
    const fetchitem = async () => {
      const result = await getActiveItemForProject(headerObj.WPSH_Project_No);
      const filteredResult = result.filter(item => item.wld_itemcode && item.wld_itemcode.trim() !== "");
      setItemActive(filteredResult);
    };

    let wps_detail = detailObj.filter((item) => item.WPSD_Process !== "");
    if (wps_detail.length <= 0) {
      wps_detail = detailObj;
    }

    const fetchUserMaster = async () => {
      const result = await getAllUserMaster();
      const active = result.filter((item) => item.um_status === "Active");
      setUsers(active);
    };



    const [error, setError] = useState({
      WPSH_WPS_No: {},
      WPSH_WPS_Revi_No: {},
      WPS_QualifiedTo: {},
      WPSH_WPS_Date: {},
      WPSH_SupportingPQR: {},
      WPSD_WP_Type: {},
      WPSD_WP_MinimumPreheatTemp: {},
      WPSD_WP_MaximumInterpassTemp: {},
      WPSD_WP_PostHeating: {},
      WPSD_WP_TungstenType: {},
      WPSD_WP_WeldPosition: {},
      WPSD_WP_WeldProgression: {},
      WPSD_WP_NoofPasses: {},
      WPSD_WP_LayerNumber: {},
      WPSD_WP_FillerMetalSIze: {},
      WPSD_WP_ItemCode: {},
      WPSD_WP_BatchNumber: {},
      WPSD_WP_Amperes: {},
      WPSD_WP_Pulsing_current: {},
      WPSD_WP_Pulsing_current_others: {},
      WPSD_WP_Volts: {},
      WPSD_WP_TravelSpeed: {},
      WPSD_WP_HeatInput: {},
      WPSD_WP_CurrentPolarity: {},
      WPSD_WP_ArcVoltageControl: {},
      WPSD_WP_ShieldingGasType: {},
      WPSD_WP_ShieldingFlowRate: {},
      WPSD_WP_BackingGasType: {},
      WPSD_WP_BackingFlowRate: {},
      WPSD_WP_AuxiGasShieldSystem: {},
      WPSH_Tech_Expansion: {},
      WPSH_Tech_StringWave: {},
      WPSH_Tech_MethodofCleaning: {},
      WPSH_Tech_OrifceCupSize: {},
      WPSH_Tech_SingleMultiElectrode: {},
      WPSH_Tech_Oscillation: {},
      WPSH_Tech_Peening: {},
      WPSH_Tech_ClosedtooutChamber: {},
      WPSH_Tech_UseOfThermalProcess: {},

      WPSH_PWHeatTre_Temperature: {},
      WPSH_PWHeatTre_Time: {},
      WPSH_PWHeatTre_Type: {},
      WPSH_PWHeatTre_Wrap_insulation_material: {},
      WPSH_PWHeatTre_Heating_Rate: {},
      WPSH_PWHeatTre_Cooling_Rate: {},
      WPSH_PWHeatTre_LoadingTemp: {},
      WPSH_PWHeatTre_UnloadingTemp: {},
      WPSH_PWHeatTre_PWHTNotes: {},
      WPSH_Notes: {},
      WPSH_PreparedBy_Name: {},
      WPSH_PreparedBy_Date: {},
      WPSH_ApprovedBy_Name: {},
      WPSH_ApprovedBy_Date: {},
      WPSH_PreparedBy_Remark: {},
      WPSH_ApprovedBy_Remark: {},
    });

    const validate = async () => {
      const page1Fields = Tubesheet_WPSPage1;
      const page2Fields = Tubesheet_WPSPage2;
      const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");

      const validationResult = validateForm({
        headerObj,
        detailObj: detaildata,
        requiredFields: { ...page1Fields, ...page2Fields },
        detailConfig: WPS_Tubesheet_Detail,
        currentErrors: error,
        todayDate,
      });
      
      let isError = validationResult.isError;
      let finalErrors = validationResult.errors;
      
      // Add signature validation only for approve/reject actions
      if ((headerObj.WPSH_Status === "Approved" || headerObj.WPSH_Status === "Rejected") && !headerObj.WPSH_PreparedBy_Name) {
        isError = true;
        finalErrors.WPSH_PreparedBy_Name = { status: true, message: "This field is required" };
      }
      if ((headerObj.WPSH_Status === "Approved" || headerObj.WPSH_Status === "Rejected") && !headerObj.WPSH_ApprovedBy_Name) {
        isError = true;
        finalErrors.WPSH_ApprovedBy_Name = { status: true, message: "This field is required" };
      }
      
      setError(finalErrors);
      return isError;
    };

    const handleAdd = async (approvalstatus) => {
      let handleaddresult = true;
      let previousStatus = headerObj.WPSH_Status;

      // Handle status like WPQ does
      if (headerObj?.WPSH_Approval_Status !== undefined) {
        headerObj.WPSH_Status = headerObj?.WPSH_Approval_Status;
      } else {
        handleStatusChange(headerObj, location, action, approvalstatus);
      }
      
      handleaddresult = handleHeaderDetailAdd(
        headerObj,
        detailObj,
        location
      );

      if (
        action === Action.ActionEdit &&
        previousStatus === Status.StatusApproved //only if its Approved add logs
      ) {
        let logObj = {
          WPSH_Project_No_log:
            headerObj !== undefined ? headerObj.WPSH_Project_No : "",
          WPSH_WPS_No_log: headerObj !== undefined ? headerObj.WPSH_WPS_No : "",
          WPSH_User_Name_log: sessionStorage.getItem("UserName"),
          WPSH_User_Id_log: sessionStorage.getItem("UserId"),
          WPSH_Status_log: "",
        };
        await AddLogs(logObj);
      }

      if (!handleaddresult || handleaddresult == MessageTypes.SpecialCharacters) {
        headerObj.WPSH_Status = previousStatus;
      }
      return handleaddresult;
    };


    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, isError);
      return { isError, temperror };
    };



    const handleSubmitTemp = () => handleGeneralSubmitTemp(
      IsEdited,
      validateTemp,
      handleAdd,
      setLoading,
      setIsEdited,
      setIsEditedPage2
    );

    const handleSubmit = () => handleGeneralSubmit(validate, handleAdd, setLoading, setIsEditedPage2, Status.StatusPending);


    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        if (res == MessageTypes.Success) {
          let read = DisableFields(
            headerObj.WPSH_Status,
            headerObj.WPSH_Prepared_By,
            Status,
            Action,
            action
          );
          if (read) setBtnDisabled("disabled");
        }
        return res;
      },

      funcOnNextTemp: async () => {
        let res = false;

        res = await handleSubmitTemp();

        return res;
      },
    }));

    const fetchapproveUserProfile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewapproved,
        avatar.defaultimg
      );
    };

    const fetchbyuserprofile = async (userprofile) => {
      await fetchImagePreview(
        folderwld,
        userprofile,
        setPreviewuser,
        avatar.defaultimg
      );
    };

    useEffect(() => {
      fetchUserMaster();
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.wps_signaturePrepared !== "") {
        fetchbyuserprofile(headerObj?.wps_signaturePrepared);
      }
      if ((action === Action.ActionEdit || action === Action.ActionCopy) && headerObj?.wps_signatureApproved !== "") {
        fetchapproveUserProfile(headerObj?.wps_signatureApproved);
      }
    }, []);


    const [valueNotes, setValueNotes] = useState("");

    const handleChangeRadio = async (e) => {
      setIsEdited(true);
      const { name, value } = e.target;
      
      // Only validate signatures for approve/reject
      if ((value === "Approved" || value === "Rejected")) {
        let hasError = false;
        let tempErrors = { ...error };
        
        if (!headerObj.WPSH_PreparedBy_Name) {
          hasError = true;
          tempErrors.WPSH_PreparedBy_Name = { status: true, message: "This field is required" };
        }
        if (!headerObj.WPSH_ApprovedBy_Name) {
          hasError = true;
          tempErrors.WPSH_ApprovedBy_Name = { status: true, message: "This field is required" };
        }
        
        if (hasError) {
          setError(tempErrors);
          showWarning("Cannot Approve or Reject without Prepared By and Approved By signatures.");
          return; // Exit without updating radio button state
        }
      }
      
      // Update radio button state
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };

    const validate2 = async (detaildata) => {
      const validationResult = validateForm({
        headerObj,
        detailObj: detaildata,
        requiredFields: {},
        detailConfig: WPS_Tubesheet_Detail,
        currentErrors: error
      });
      setError(validationResult.errors);
      return validationResult.isError;
    };

    const handleChange = (e) => handleHeaderchange(
      e,
      { setheaderObj, setError },
      { action, setIsEdited, setEditedPage1: null, setEditedPage2: setIsEditedPage2, setEditedPage3: null },
      error
    )

    const handleChangeTube = (row, col, key, e) => handleArrayChange(
      { row, col },
      key,
      e,
      { detailObj, setdetailObj },
      { setError },
      { action, setIsEdited, setIsEditedPage2 }
    )

    const handleChangedetailsarray = (e, i) => {
      handleDetailChange(
        e,
        i,
        { detailObj, setdetailObj },
        { setError },
        { action, setIsEdited, setIsEditedPage2 }
      )
    }

    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <WPSHeader headerObj={headerObj}></WPSHeader>
        <Row className="mb-4" style={{ padding: "28px 48px" }}>
          <span
            className="WPS-blue-text"
            style={{ position: "relative", top: "10px" }}
          >
            Welding Procedure
          </span>
          <Col>
            <Table bordered responsive="sm" className="text-center tube-col-widths">
              <tbody>
                <WPS_Process_Grid_InputProcess_tubesheet
                  wps_detail={wps_detail}
                  maxLength={10}
                  disabled={isDisabled}
                  ColumnHeader="Welding Process"
                  type="text"
                  name="WPSD_WP_WeldingProcess"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPS_Process_Grid_InputProcess_tubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={10}
                  disabled={isDisabled}
                  ColumnHeader="Type"
                  status={error.WPSD_WP_Type?.status}
                  message={error.WPSD_WP_Type?.message}
                  type="text"
                  name="WPSD_WP_Type"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>

                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_MinimumPreheatTempTube}
                  ColumnHeader="Minimum Preheat Temp"
                  Columndimension="°C"
                  status={error.WPSD_WP_MinimumPreheatTemp?.status}
                  message={error.WPSD_WP_MinimumPreheatTemp?.message}
                  type="text"
                  name="WPSD_WP_MinimumPreheatTemp"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_MaximumInterpassTempTube}
                  ColumnHeader=" Maximum Interpass Temp"
                  Columndimension="°C"
                  status={error.WPSD_WP_MaximumInterpassTemp.status}
                  message={error.WPSD_WP_MaximumInterpassTemp.message}
                  type="text"
                  name="WPSD_WP_MaximumInterpassTemp"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_PostHeating}
                  ColumnHeader="Post Heating/DHT"
                  status={error.WPSD_WP_PostHeating.status}
                  message={error.WPSD_WP_PostHeating.message}
                  type="text"
                  name="WPSD_WP_PostHeating"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  validatorFn={isAlphanumericWithPlusAmpersandEqualsPlusMinus}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxlength_WPS.WPSD_WP_TungstenType}
                  ColumnHeader="Tungsten Type and Size"
                  Columndimension="mm"
                  status={error.WPSD_WP_TungstenType.status}
                  message={error.WPSD_WP_TungstenType.message}
                  type="text"
                  name="WPSD_WP_TungstenType"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_WeldPosition}
                  ColumnHeader="Welding Position"
                  status={error.WPSD_WP_WeldPosition.status}
                  message={error.WPSD_WP_WeldPosition.message}
                  type="text"
                  name="WPSD_WP_WeldPosition"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxlength_WPS.WPSD_WP_WeldProgression}
                  ColumnHeader="Progression"
                  status={error.WPSD_WP_WeldProgression.status}
                  message={error.WPSD_WP_WeldProgression.message}
                  type="text"
                  name="WPSD_WP_WeldProgression"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_NoofPasses}
                  ColumnHeader="No of Passes"
                  status={error.WPSD_WP_NoofPasses.status}
                  message={error.WPSD_WP_NoofPasses.message}
                  type="text"
                  name="WPSD_WP_NoofPasses"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_LayerNumber}
                  ColumnHeader="Layer Number"
                  status={error.WPSD_WP_LayerNumber.status}
                  message={error.WPSD_WP_LayerNumber.message}
                  type="text"
                  name="WPSD_WP_LayerNumber"
                  handleChange={handleChangeTube}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_FillerMetalSIze}
                  ColumnHeader="Filler Metal Size"
                  Columndimension="mm"
                  status={error.WPSD_WP_FillerMetalSIze.status}
                  message={error.WPSD_WP_FillerMetalSIze.message}
                  type="text"
                  name="WPSD_WP_FillerMetalSIze"
                  handleChange={handleChangeTube}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Process_Grid_Select_master_data_TTS
                  data={ItemActive}
                  bluestyle={bluestyle}
                  errorstyle={errorstyle}
                  valueField="wld_itemcode"
                  labelField="wld_itemcode"
                  name="WPSD_WP_ItemCode"
                  name1="WPSD_WP_WeldDesc"
                  setdetailObj={setdetailObj}
                  detailObj={detailObj}
                  setError={setError}
                  error={error}
                  isTTS={true}
                  onInput={(e) => {
                    setError((prevState) => ({
                      ...prevState,
                      WPSD_WP_ItemCode: { status: false, message: "" },
                    }));
                  }}
                  wps_detail={wps_detail}
                  ColumnHeader="Item Code"
                  Columndimension="mm"
                  status={error.WPSD_WP_ItemCode.status}
                  message={error.WPSD_WP_ItemCode.message}
                  handleChange={handleChangedetailsarray}
                  setIsEdited={setIsEdited}
                  showPopUp={showPopUp}
                  headerObj={headerObj}
                  disabled={true}
                ></WPS_Process_Grid_Select_master_data_TTS>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_BatchNumber}
                  ColumnHeader="Batch No"
                  status={error.WPSD_WP_BatchNumber.status}
                  message={error.WPSD_WP_BatchNumber.message}
                  type="text"
                  name="WPSD_WP_BatchNumber"
                  handleChange={handleChangeTube}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_Amperes}
                  ColumnHeader="Amperes"
                  Columndimension="Amps"
                  status={error.WPSD_WP_Amperes.status}
                  message={error.WPSD_WP_Amperes.message}
                  type="text"
                  name="WPSD_WP_Amperes"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_Pulsing_current}
                  ColumnHeader="DC Pulsing Current"
                  Columndimension="Amps"
                  status={error.WPSD_WP_Pulsing_current.status}
                  message={error.WPSD_WP_Pulsing_current.message}
                  type="text"
                  name="WPSD_WP_Pulsing_current"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_Pulsing_current_others}
                  ColumnHeader="DC Pulsing Current - Others"
                  Columndimension="Amps"
                  status={error.WPSD_WP_Pulsing_current_others.status}
                  message={error.WPSD_WP_Pulsing_current_others.message}
                  type="text"
                  name="WPSD_WP_Pulsing_current_others"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_Volts}
                  ColumnHeader="Voltage"
                  Columndimension="Volts"
                  status={error.WPSD_WP_Volts.status}
                  message={error.WPSD_WP_Volts.message}
                  type="text"
                  name="WPSD_WP_Volts"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_TravelSpeed}
                  ColumnHeader="Travel Speed"
                  Columndimension="mm/min"
                  status={error.WPSD_WP_TravelSpeed.status}
                  message={error.WPSD_WP_TravelSpeed.message}
                  type="text"
                  name="WPSD_WP_TravelSpeed"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>

                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  ColumnHeader="Maximum Heat Input"
                  Columndimension="KJ/mm"
                  maxLength={maxLength_WPS.WPSD_WP_HeatInput}
                  status={error.WPSD_WP_HeatInput.status}
                  message={error.WPSD_WP_HeatInput.message}
                  type="text"
                  name="WPSD_WP_HeatInput"
                  handleChange={handleChangeTube}
                  validatorFn={isAllowDashedSpecialCharacters}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>
                <WPS_Grid_Input_2_Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_CurrentPolarity}
                  ColumnHeader="Polarity or Current Type "
                  status={error.WPSD_WP_CurrentPolarity.status}
                  message={error.WPSD_WP_CurrentPolarity.message}
                  type="text"
                  name="WPSD_WP_CurrentPolarity"
                  handleChange={handleChangeTube}
                  setError={setError}
                  isTubesheet={true}
                ></WPS_Grid_Input_2_Tubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_ArcVoltageControl}
                  ColumnHeader="Automatic Arc Voltage control"
                  status={error.WPSD_WP_ArcVoltageControl.status}
                  message={error.WPSD_WP_ArcVoltageControl.message}
                  type="text"
                  name="WPSD_WP_ArcVoltageControl"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
                <WPSProcessGridInput2Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_ShieldingGasType_Tube}
                  mainheading="Shielding"
                  ColumnHeader="Gas Type - % comp"
                  ColumnHeader1="Flow Rate"
                  Columndimension="I/min"
                  status={
                    error.WPSD_WP_ShieldingGasType.status ||
                    error.WPSD_WP_ShieldingFlowRate.status
                  }
                  message={
                    error.WPSD_WP_ShieldingGasType.message ||
                    error.WPSD_WP_ShieldingFlowRate.message
                  }
                  type="text"
                  name="WPSD_WP_ShieldingGasType"
                  name1="WPSD_WP_ShieldingFlowRate"
                  validatorFn={isAllowDashedPercentageSpecialCharacters}
                  validatorFn1={isAllowDashedSpecialCharacters}
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                  customWidth={"512px"}
                ></WPSProcessGridInput2Tubesheet>
                <WPSProcessGridInput2Tubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_BackingGasType_Tube}
                  mainheading="Backing / Trailing"
                  ColumnHeader="Gas Type - % comp"
                  ColumnHeader1="Flow Rate"
                  Columndimension="I/min"
                  status={
                    error.WPSD_WP_BackingGasType.status ||
                    error.WPSD_WP_BackingFlowRate.status
                  }
                  message={
                    error.WPSD_WP_BackingGasType.message ||
                    error.WPSD_WP_BackingFlowRate.message
                  }
                  type="text"
                  name="WPSD_WP_BackingGasType"
                  name1="WPSD_WP_BackingFlowRate"
                  validatorFn={isAllowDashedPercentageSpecialCharacters}
                  validatorFn1={isAllowDashedSpecialCharacters}
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                  customWidth={"512px"}
                ></WPSProcessGridInput2Tubesheet>
                <WPSProcessGridInputTubesheet
                  wps_detail={wps_detail}
                  maxLength={maxLength_WPS.WPSD_WP_AuxiGasShieldSystem}
                  ColumnHeader="Auxiliary gas shield system"
                  status={error.WPSD_WP_AuxiGasShieldSystem.status}
                  message={error.WPSD_WP_AuxiGasShieldSystem.message}
                  type="text"
                  name="WPSD_WP_AuxiGasShieldSystem"
                  setError={setError}
                  handleChange={handleChangedetailsarray}
                  isTubesheet={true}
                ></WPSProcessGridInputTubesheet>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row
          style={{ padding: "28px 60px", position: "relative", bottom: "30px" }}
          className="WPS-Page-row-padding"
        >
          <span
            className="WPS-blue-text"
            style={{ position: "relative", right: "10px", top: "10px" }}
          >
            Post Weld Heat Treatment (QW-407)
          </span>
          <Row className="mb-1">
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_Temperature"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_Temperature}
                status={error.WPSH_PWHeatTre_Temperature.status}
                value={headerObj.WPSH_PWHeatTre_Temperature}
                onChange={handleChange}
                label="Post Weld H/T Temp(°C)"
                message={error.WPSH_PWHeatTre_Temperature.message}
                error={error}
                setError={setError}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="±+-"
                customMessage="Special Characters # & % $ ' < > = ; not allowed"
              ></SingleInput>
            </Col>
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_Time"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_Temperature}
                status={error.WPSH_PWHeatTre_Time.status}
                value={headerObj.WPSH_PWHeatTre_Time}
                onChange={handleChange}
                label="Time (Minutes)"
                message={error.WPSH_PWHeatTre_Time.message}
                error={error}
                setError={setError}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="-"
                customMessage="Special Characters # & % $ ' < > = ; not allowed"
              ></SingleInput>

            </Col>
            <Col className="mb-1" md={3}>
              <General_Single_Input_select
                name="WPSH_PWHeatTre_Type"
                disabled={isDisabled}
                value={headerObj.WPSH_PWHeatTre_Type}
                status={error.WPSH_PWHeatTre_Type.status}
                message={error.WPSH_PWHeatTre_Type.message}
                handleSelectChange={handleChange}
                label="Type"
                array={WPSH_PWHeatTre_Type}
              ></General_Single_Input_select>
            </Col>
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_Heating_Rate"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_Heating_Rate}
                status={error.WPSH_PWHeatTre_Heating_Rate.status}
                value={headerObj.WPSH_PWHeatTre_Heating_Rate}
                onChange={handleChange}
                label="Heating Rate (°C/Hr)"
                message={error.WPSH_PWHeatTre_Heating_Rate.message}
                error={error}
                setError={setError}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="+&=±-"
                customMessage="Special Characters # % $ ' < > ; not allowed"
              ></SingleInput>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col className="mb-1" md={3}>
              <General_Single_Input_select
                name="WPSH_PWHeatTre_Wrap_insulation_material"
                disabled={isDisabled}
                value={headerObj.WPSH_PWHeatTre_Wrap_insulation_material}
                status={error.WPSH_PWHeatTre_Wrap_insulation_material.status}
                message={error.WPSH_PWHeatTre_Wrap_insulation_material.message}
                handleSelectChange={handleChange}
                label="Wrap in Insulation Material"
                array={Wrap_insulation_material}
              ></General_Single_Input_select>
            </Col>
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_Cooling_Rate"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_Cooling_Rate_Tube}
                status={error.WPSH_PWHeatTre_Cooling_Rate.status}
                value={headerObj.WPSH_PWHeatTre_Cooling_Rate}
                onChange={handleChange}
                label=" Cooling Rate (°C/Hr)"
                message={error.WPSH_PWHeatTre_Cooling_Rate.message}
                error={error}
                setError={setError}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="+&=±-"
                customMessage="Special Characters # % $ ' < > ; not allowed"
              ></SingleInput>
            </Col>
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_LoadingTemp"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_LoadingTemp}
                status={error.WPSH_PWHeatTre_LoadingTemp.status}
                value={headerObj.WPSH_PWHeatTre_LoadingTemp}
                onChange={handleChange}
                label=" Loading Temp (°C)"
                message={error.WPSH_PWHeatTre_LoadingTemp.message}
                error={error}
                setError={setError}
              ></SingleInput>
            </Col>
            <Col className="mb-1" md={3}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_UnloadingTemp"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_UnloadingTemp}
                status={error.WPSH_PWHeatTre_UnloadingTemp.status}
                value={headerObj.WPSH_PWHeatTre_UnloadingTemp}
                onChange={handleChange}
                label=" Unloading Temp (°C)"
                message={error.WPSH_PWHeatTre_UnloadingTemp.message}
                error={error}
                setError={setError}
              ></SingleInput>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col className="mb-1" md={12}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_PWHeatTre_PWHTNotes"
                type="text"
                maxLength={maxLength_WPS.WPSH_PWHeatTre_PWHTNotes}
                status={error.WPSH_PWHeatTre_PWHTNotes.status}
                value={headerObj.WPSH_PWHeatTre_PWHTNotes}
                onChange={handleChange}
                label=" PWHT Notes"
                message={error.WPSH_PWHeatTre_PWHTNotes.message}
                error={error}
                setError={setError}
                allowlistfunction={isAllowCustomSpecialCharacters}
                allowcharacters="+&=±-"
                customMessage="Special Characters # % $ ' < > ; not allowed"
              ></SingleInput>
            </Col>
          </Row>
        </Row>

        <Row
          style={{ padding: "0px 60px", position: "relative", bottom: "30px" }}
        >

          <span
            className="WPS-blue-text"
            style={{ position: "relative", right: "12px", top: "10px" }}
          >
            Other Variables
          </span>
          <Row className="mb-1">
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_Expansion"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_Expansion}
                status={error.WPSH_Tech_Expansion.status}
                value={headerObj.WPSH_Tech_Expansion}
                onChange={handleChange}
                label="Expansion"
                message={error.WPSH_Tech_Expansion.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_StringWave"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_StringWave.status}
                value={headerObj.WPSH_Tech_StringWave}
                onChange={handleChange}
                label="String & Wave"
                message={error.WPSH_Tech_StringWave.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_MethodofCleaning"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_MethodofCleaning.status}
                value={headerObj.WPSH_Tech_MethodofCleaning}
                onChange={handleChange}
                label=" Method of Cleaning"
                message={error.WPSH_Tech_MethodofCleaning.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_OrifceCupSize"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_OrifceCupSize.status}
                value={headerObj.WPSH_Tech_OrifceCupSize}
                onChange={handleChange}
                label="Orifce Cup Size(mm)"
                message={error.WPSH_Tech_OrifceCupSize.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_SingleMultiElectrode"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_SingleMultiElectrode.status}
                value={headerObj.WPSH_Tech_SingleMultiElectrode}
                onChange={handleChange}
                label="Single/Multi Electrode"
                message={error.WPSH_Tech_SingleMultiElectrode.message}
                error={error}
                setError={setError}

              ></SingleInput>


            </Col>

            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_Oscillation"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_Oscillation.status}
                value={headerObj.WPSH_Tech_Oscillation}
                onChange={handleChange}
                label="Oscillation"
                message={error.WPSH_Tech_Oscillation.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
          </Row>
          <Row className="mb-1">
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_Peening"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_Peening.status}
                value={headerObj.WPSH_Tech_Peening}
                onChange={handleChange}
                label="Peening"
                message={error.WPSH_Tech_Peening.message}
                error={error}
                setError={setError}
              ></SingleInput>
            </Col>
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_ClosedtooutChamber"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_ClosedtooutChamber.status}
                value={headerObj.WPSH_Tech_ClosedtooutChamber}
                onChange={handleChange}
                label="Closed To Out Chamber"
                message={error.WPSH_Tech_ClosedtooutChamber.message}
                error={error}
                setError={setError}
              ></SingleInput>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col md={6}>
              <SingleInput
                disabled={isReadonly}
                name="WPSH_Tech_UseOfThermalProcess"
                type="text"
                maxLength={maxLength_WPS.WPSH_Tech_StringWave}
                status={error.WPSH_Tech_UseOfThermalProcess.status}
                value={headerObj.WPSH_Tech_UseOfThermalProcess}
                onChange={handleChange}
                label="Use Of Thermal Processr"
                message={error.WPSH_Tech_UseOfThermalProcess.message}
                error={error}
                setError={setError}

              ></SingleInput>

            </Col>
          </Row>
        </Row>
        <Row style={{ padding: "28px 48px", position: "relative", bottom: "40px" }}>
          <span className="WPS-blue-text" style={{ position: "relative", top: "10px" }}>
            Notes (Only the first six lines in the notes will appear in the WI Slip with a limit of 120 characters per line)
          </span>
          <Col md={12}>
            <SingleInputTextAreaNotesWPS
              disabled={isReadonly}
              name="WPSH_Notes"
              type="text"
              style={{ height: "250px", resize: "none" }}
              maxLength={1500}
              status={error.WPSH_Notes.status}
              value={headerObj.WPSH_Notes ? headerObj.WPSH_Notes : valueNotes}
              handleChange={(e) => handleChangeNotes(e, setIsEdited, null, null, setheaderObj, setValueNotes)}
              onKeyDown={handleKeyDown}
              label="Notes"
              message={error.WPSH_Notes.message}
              onInput={(e) => {
                let error = isSpecialCharactersNotes(e.target.value);
                setError((prevState) => ({
                  ...prevState,
                  WPSH_Notes: error,
                }));
              }}
            ></SingleInputTextAreaNotesWPS>
          </Col>
        </Row>
        {/* -------------------------prepared by --------------------------------*/}
        <UnifiedSignatureSection
          sessionType="WPS"
          sectionType="prepared"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewuser}
          fetchUserProfile={fetchbyuserprofile}
          isReadonly={isReadonly}
          action={action}
          setIsEdited={setIsEdited}
          Band={Band}
          maxLength={50}
          todayDate={todayDate}
        />

        {/* -------------------------approved by --------------------------------*/}
        <UnifiedSignatureSection
          sessionType="WPS"
          sectionType="approved"
          headerObj={headerObj}
          setheaderObj={setheaderObj}
          users={users}
          error={error}
          setError={setError}
          previewImage={previewapproved}
          fetchUserProfile={fetchapproveUserProfile}
          isReadonly={isReadonly}
          action={action}
          setIsEdited={setIsEdited}
          Band={Band}
          handleChangeRadio={handleChangeRadio}
          maxLength={280}
        />
        <RenderIf isTrue={popUp.type === "Single" && showForm}>
          <SingleValuePopUp
            show={showForm}
            onHide={() => setShowForm(false)}
            setSelected={setPopUpData}
            masterName={popUp.name}
            paramkey={popUp.key}
            paramvalue={popUp.value}
            data={ItemActive}
            backdrop="static"
            title="Item Code"
          />
        </RenderIf>
      </Row>
    );
  }
);

export default WPSTubesheetProcedureSpec;
